import { GroupData } from "./reducer";

// load user groups
export const LOAD_GROUPS = "bonfire/groups/LOAD_GROUPS";
interface LoadGroupsAction {
  type: typeof LOAD_GROUPS;
}

export const LOAD_GROUPS_SUCCESS = "bonfire/groups/LOAD_GROUPS_SUCCESS";
interface LoadGroupsSuccessAction {
  type: typeof LOAD_GROUPS_SUCCESS;
  result: any;
}

export const LOAD_GROUPS_FAIL = "bonfire/groups/LOAD_GROUPS_FAIL";
interface LoadGroupsFailAction {
  type: typeof LOAD_GROUPS_FAIL;
}

// ADDING new groups
export const ADD_GROUP_REQUEST = "bonfire/groups/ADD_GROUP_REQUEST";
interface AddGroupRequestAction {
  type: typeof ADD_GROUP_REQUEST;
}

export const ADD_GROUP = "bonfire/groups/ADD_GROUP";
interface AddGroupAction {
  type: typeof ADD_GROUP;
}

export const ADD_GROUP_SUCCESS = "bonfire/groups/ADD_GROUP_SUCCESS";
interface AddGroupSuccessAction {
  type: typeof ADD_GROUP_SUCCESS;
}

export const ADD_GROUP_FAIL = "bonfire/groups/ADD_GROUP_FAIL";
interface AddGroupFailAction {
  type: typeof ADD_GROUP_FAIL;
  error: any;
}

// save group changes
export const SAVE_GROUP_REQUEST = "bonfire/groups/SAVE_GROUP_REQUEST";
interface SaveGroupRequestAction {
  type: typeof SAVE_GROUP_REQUEST;
}

export const SAVE_GROUP = "bonfire/groups/SAVE_GROUP";
interface SaveGroupAction {
  type: typeof SAVE_GROUP;
}

export const SAVE_GROUP_SUCCESS = "bonfire/groups/SAVE_GROUP_SUCCESS";
interface SaveGroupSuccessAction {
  type: typeof SAVE_GROUP_SUCCESS;
}

export const SAVE_GROUP_FAIL = "bonfire/groups/SAVE_GROUP_FAIL";
interface SaveGroupFailAction {
  type: typeof SAVE_GROUP_FAIL;
  error: any;
}

// GUI CONTROL
export const ADDING_GROUP = "bonfire/groups/ADDING_GROUP";
interface AddingGroupAction {
  type: typeof ADDING_GROUP;
}

export const EDITING_GROUP = "bonfire/groups/EDITING_GROUP";
interface EditinGroupAction {
  type: typeof EDITING_GROUP;
  row: GroupData;
}

export const END_ACTION = "bonfire/groups/END_ACTION";
interface EndActionAction {
  type: typeof END_ACTION;
}

export const EDITING_GROUP_FORM = "bonfire/groups/EDITING_GROUP_FORM";
interface EditingGroupFormAction {
  type: typeof EDITING_GROUP_FORM;
  input_id: keyof GroupData;
  input_value: string;
}

export const VALIDATE_FORM_ERROR = "bonfire/groups/VALIDATE_FORM_ERROR";
interface ValidateFormErrorAction {
  type: typeof VALIDATE_FORM_ERROR;
  error: string[];
}

export type GroupsAction =
  | LoadGroupsAction
  | LoadGroupsSuccessAction
  | LoadGroupsFailAction
  | AddGroupRequestAction
  | AddGroupAction
  | AddGroupSuccessAction
  | AddGroupFailAction
  | SaveGroupRequestAction
  | SaveGroupAction
  | SaveGroupSuccessAction
  | SaveGroupFailAction
  | AddingGroupAction
  | EditinGroupAction
  | EndActionAction
  | EditingGroupFormAction
  | ValidateFormErrorAction;
